import { Edit, ReferenceInput, SimpleForm, TextInput } from "react-admin";

const EntityEdit = () =>(
    <Edit>
        <SimpleForm>
            <ReferenceInput source="id" reference="entities"/>
            <TextInput source="name" label="Full name" />
            <TextInput source="pseudo" label="Pseudo" />
        </SimpleForm>
    </Edit>
);

export default EntityEdit;